.checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-style: solid;
}
